import React from 'react'
import { MdOutlineArrowLeft } from "react-icons/md";


const Beverage = () => {
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-wrap w-full mb-20">
            <div class="lg:w-1/2 w-full mb-6 lg:mb-0">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Beverage Cuisines
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/menu">
                  <p className="text-blue-700">Back</p>
                </a>
              </div>
            </div>
            {/* <p class="lg:w-1/2 w-full leading-relaxed text-gray-500">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p> */}
          </div>
          <div class=" lg:grid lg:grid-cols-6 grid grid-cols-2  -m-4 mx-2 mt-0.5 text-center  ">
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Chai (Masala Tea).jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  CHAI (MASALA TEA)
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Kesar Pista Chai.avif"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  KESAR PISTA CHAI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Filter Coffee.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  FILTER COFFEE
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Badam Milk.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  BADAM MILK
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Buttermilk.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  BUTTERMILK
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Thandai.webp"
                    alt="Thandai"
                    name="Thandai"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  THANDAI
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Shikanji (Nimbu Pani).webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  SHIKANJI (NIMBU PANI)
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="Images\Beverage\Mango Lassi.webp"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  MANGPO JUICE
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Watermelon Juice.avif"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  WATERMELON JUICE
                </p>
              </div>
            </div>
            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Jal Jeera.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  JAL JEERA
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Nannari Sherbet.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  NANNARI SHERBET
                </p>
              </div>
            </div>

            <div class="p-4 md:w-1/4 lg:w-[200px]">
              <div class="border-2 border-red-900 px-4 py-4 rounded-lg   shadow-2xl">
                <div class=" rounded-md     shadow-2xl ">
                  <img
                    src="\Images\Beverage\Sugarcane Juice.jpg"
                    alt="Gobi_Manchurian"
                    name="Gobi_Manchurian"
                    className=" w-60 h-20 rounded-md "
                  />
                </div>
                <p className="text-black text-xs font-extrabold mt-5" id="name">
                  SUGARCANE JUICE
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Beverage